import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class AccordionList extends React.PureComponent<AccordionList.Props, AccordionList.State> {
  public static sectionId = 'acdlist';

  public render(): JSX.Element {
    const { blocks } = this.props.section
    return (
      <section className={'dynamic-accordion-list'}>
        <div className={'w-full md:w-5/6 mx-auto'}>
          <div className={'w-full md:w-4/5 px-1-6 md:px-0-4 mx-auto mb-1-6'}>
            {blocks.map((block, i) => <Snippets.AccordionListItem key={i} block={block}/>)}
          </div>
        </div>
      </section>
    )
  }
}

export namespace AccordionList {
  export interface Options extends ShopifyNext.Section<{
  }> { }

  export interface Props extends GlobalProps {
    section: AccordionList.Options;
  }
  export interface State { }
}
